import React from 'react';
import {
  OrderedListOutlined,
  WechatWorkOutlined,
  DashboardOutlined,
  BlockOutlined,
  GroupOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';

const SideMenu = () => {
  const items = [
    {
      key: 'dashboard',
      label: <Link to="dashboard" className='font-semibold'>Хянахсамбар</Link>,
      icon: <DashboardOutlined />,
    },
    {
      key: 'groupList',
      label: <Link to="groupList" className='font-semibold'>Грөүп жагсаалт</Link>,
      icon: <GroupOutlined />,
    },
    {
      key: 'chat',
      label: 'Чат удирдлага',
      icon: <WechatWorkOutlined />,
      children: [
        {
          key: 'chatList',
          label: <Link to="chat/userList">Хэрэглэгчийн жагсаалт</Link>,
          icon: <OrderedListOutlined />,
        },
        {
          key: 'block',
          label: <Link to="chat/blockList">Хориглосон гишүүд</Link>,
          icon: <BlockOutlined />,
        },
      ],
    },
    {
      key: 'profile',
      label: <Link to="profile" className='font-semibold'>Профайл</Link>,
      icon: <UserOutlined />,
      children: [
        {
          key: 'info',
          label: <Link to="profile/info">Админ мэдээлэл</Link>,
          icon: <OrderedListOutlined />,
        },
        {
          key: 'password',
          label: <Link to="profile/password">Нууц үг солих</Link>,
          icon: <BlockOutlined />,
        },
      ],

    },
  ];

  return (
    <Menu theme="light" mode="inline" className='max-w-[250px] pt-3' items={items} />
  );
};

export default SideMenu;
